import { EMAIL_IMAGE_PLACEHOLDER_LOGO_SIZE } from './emailImagePlaceholders'

const DEFAULT_LOGO_MAX = { maxHeight: 60, maxWidth: 200 }
const RESORT_DISCOVERY_LOGO_MAX = { maxHeight: 120, maxWidth: 160 }
const EDITORIAL_EVENT_LOGO_MAX = { maxHeight: 168, maxWidth: 220 }
const CINEMATIC_CONFIRM_LOGO_MAX = { maxHeight: 60, maxWidth: 260 }

export function getTemplateLogoLimits(templateKey = 'default') {
  if (templateKey === 'resortDiscovery') {
    return RESORT_DISCOVERY_LOGO_MAX
  }

  if (templateKey === 'editorialEvent') {
    return EDITORIAL_EVENT_LOGO_MAX
  }

  if (templateKey === 'cinematicConfirm') {
    return CINEMATIC_CONFIRM_LOGO_MAX
  }

  return DEFAULT_LOGO_MAX
}

function fitLogoDimensions(naturalWidth, naturalHeight, limits = DEFAULT_LOGO_MAX) {
  const { maxHeight = 60, maxWidth = 200 } = limits
  const ratio = naturalWidth / naturalHeight
  let height = maxHeight
  let width = height * ratio

  if (width > maxWidth) {
    width = maxWidth
    height = width / ratio
  }

  return { width: `${Math.round(width)}px`, height: `${Math.round(height)}px` }
}

export function getPlaceholderLogoDimensions(templateKey = 'default') {
  return fitLogoDimensions(
    EMAIL_IMAGE_PLACEHOLDER_LOGO_SIZE.width,
    EMAIL_IMAGE_PLACEHOLDER_LOGO_SIZE.height,
    getTemplateLogoLimits(templateKey)
  )
}

export function calculateLogoDimensions(logoUrl, limits = DEFAULT_LOGO_MAX) {
  return new Promise(resolve => {
    if (!logoUrl) {
      resolve({ width: '120px', height: '60px', loaded: false })
      return
    }

    const newImg = new Image()
    newImg.onload = function () {
      const fitted = fitLogoDimensions(newImg.width, newImg.height, limits)

      resolve({
        width: fitted.width,
        height: fitted.height,
        loaded: true
      })
    }
    newImg.onerror = function () {
      resolve({ width: '120px', height: '60px', loaded: false })
    }
    newImg.src = logoUrl
  })
}

export async function applyLogoDimensions(emailState, brandLogoUrl, templateKey) {
  const logoUrl = emailState.logoUrl || brandLogoUrl
  if (!logoUrl) {
    return emailState
  }

  const resolvedTemplateKey =
    templateKey || emailState.shellTemplateKey || emailState.selectedTemplate || 'default'
  const dimensions = await calculateLogoDimensions(logoUrl, getTemplateLogoLimits(resolvedTemplateKey))

  if (!dimensions.loaded) {
    return emailState
  }

  return {
    ...emailState,
    logoUrl,
    logoWidth: dimensions.width,
    logoHeight: dimensions.height
  }
}
